import { Course } from '../../objects/index.js';

/**
 * Checks if a node is a Course object.
 */
export const isCourse = (node: unknown): node is Course => {
  return !!(node && (node as Course).isCourse);
};
